// A half-written message, kept per conversation so a page reload or a closed tab does not
// take it away. Kept in the browser's local store in every environment. A browser that
// refuses the store simply keeps no draft. `clearDrafts()` runs at sign-out so no draft
// outlives the person who wrote it.

const PREFIX = 'mor.draft.';
const keyFor = (threadId: string): string => `${PREFIX}${threadId}`;

export function readDraft(threadId: string): string {
  try {
    return window.localStorage.getItem(keyFor(threadId)) ?? '';
  } catch {
    return '';
  }
}

export function writeDraft(threadId: string, text: string): void {
  try {
    if (text === '') {
      window.localStorage.removeItem(keyFor(threadId));
    } else {
      window.localStorage.setItem(keyFor(threadId), text);
    }
  } catch {
    // No storage, no draft; the box behaves as it always did.
  }
}

export function clearDrafts(): void {
  try {
    const store = window.localStorage;
    const keys: string[] = [];
    for (let i = 0; i < store.length; i += 1) {
      const key = store.key(i);
      if (key !== null && key.startsWith(PREFIX)) {
        keys.push(key);
      }
    }
    for (const key of keys) {
      store.removeItem(key);
    }
  } catch {
    // No storage, nothing to clear.
  }
}
